import React from 'react';
import tinycolor from 'tinycolor2';

const MinimalistToucan = (props) => {
  const { radius, cells } = props;
  const base = cells[1].background;

  return (
    <svg width={`${radius * 2.5}px`} height={`${radius * 2}px`} x={`-${radius * 1.5}px`} y={`-${radius}px`} viewBox="0 0 250 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard">
            <g id="Group">
                <path d="M150,0 C94.771525,0 50,44.771525 50,100 L150,100 L150,0 Z" id="Oval-2" fill={base}></path>
                <path d="M50,200 C105.228475,200 150,155.228475 150,100 L50,100 L50,200 Z" id="Oval-2" fill={base}></path>
                <path d="M50,150 C22.3857625,150 0,127.614237 0,100 L50,100 L50,150 Z" id="Oval-2" fill={base}></path>
                <path d="M50,200 C36.1928813,200 25,188.807119 25,175 L50,175 L50,200 Z" id="Oval-2" fill={base}></path>
                <path d="M150,0 C205.228475,0 250,44.771525 250,100 L150,100 L150,0 Z" id="Oval-2" fill="#F89F1C"></path>
            </g>
        </g>
    </g>
    </svg>
  )
}
export default MinimalistToucan;

export function resize(props) {
  const {radius, minX, maxY} = props;

  return {
    ...props,
    minX: minX + radius * 0.5,
    maxY: maxY + radius,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/minimalist/toucan/index.js